import loadingTools from './loadingTools';
import qtiConstants from '../../qti/Constants';
import requirementsParser from './requirementsParser';
import ACEEditorLoader from './libraries/ACEEditor';
import MathJaxLoader from './libraries/MathJax';
import PDFJSLoader from './libraries/PDFJS';
import MomentTimezone from './libraries/MomentTimezone';

const { MEDIA_RECORDER_POLYFILL } = qtiConstants.staticLibPaths;

const ResourceInitializer = {
    async loadMediaRecorder() {
        if (window.MediaRecorder === undefined) {
            await loadingTools.loadLibrary(`${MEDIA_RECORDER_POLYFILL}`);
            window.MediaRecordedIsPolyfilled = true;
        }
        return window.MediaRecorder;
    },

    loadSymbolaFonts() {
        const path = `${window.assetRoot}/fonts/`;
        /* eslint-disable max-len */
        const css = `
@font-face {
  font-family: Symbola;
  src: url(${path}Symbola.eot);
  src: local("Symbola Regular"), local("Symbola"), url(${path}Symbola.woff2) format("woff2"), url(${path}Symbola.ttf) format("truetype"), url(${path}Symbola.otf) format("opentype");
 }`;
        /* eslint-enable max-len */
        loadingTools.injectStyle(css);

        return loadingTools.loadFont('Symbola');
    },

    loadFontAwesome() {
        const path = `${window.assetRoot}/fonts/`;
        /* eslint-disable max-len */
        const css = `
@font-face {
  font-family: 'FontAwesome';
  src: url(${path}fontawesome-webfont.eot);
  src: url(${path}fontawesome-webfont.eot?#iefix&v=4.6.1) format("embedded-opentype"), url(${path}fontawesome-webfont.woff2) format("woff2"), url(${path}fontawesome-webfont.ttf) format("truetype");
  font-weight: normal;
  font-style: normal;
}`;
        /* eslint-enable max-len */
        loadingTools.injectStyle(css);

        return loadingTools.loadFont('FontAwesome');
    },

    getAllQuestions(assessment) {
        return assessment.sections.reduce((questionsArr, section) => {
            return questionsArr.concat(section.questions);
        }, []);
    },

    async initBaseResources() {
        return Promise
            .all([
                MomentTimezone.init(),
                this.loadMediaRecorder(),
            ])
            .then(() => console.log('ALL BASE RESOURCES LOADED'));
    },

    async initOptionalResources(assessment) {
        const questions = this.getAllQuestions(assessment);
        const promisedDependencies = [];

        if (requirementsParser.isAceEditorRequired(questions)) {
            promisedDependencies.push(ACEEditorLoader.init(questions));
        }

        if (requirementsParser.isPdfJsRequired(questions)) {
            promisedDependencies.push(PDFJSLoader.init());
        }

        if (requirementsParser.isCkEditorRequired(questions)) {
            // promisedDependencies.push(this.loadCkEditorAndExtraResources());
        }

        // if (requirementsParser.isSymbolaFontRequired(questions)) {
        //     promisedDependencies.push(this.loadSymbolaFonts());
        // }

        if (requirementsParser.isMathJaxRequired(questions)) {
            promisedDependencies.push(MathJaxLoader.init());
        }

        try {
            await Promise.all(promisedDependencies);
            window.console.log('LIBRARY_LOADER: OK');
        } catch (error) {
            window.console.log('LIBRARY_LOADER: ERROR');
            window.console.log(error);
        }
    },
};

export default ResourceInitializer;
